import React from 'react'

interface IconProps {
  icon: string
  size?: React.CSSProperties["width"]
  bgColor?: React.CSSProperties["backgroundColor"]
}

const Icon: React.FC<IconProps> = ({ size = '18px', bgColor = 'white', icon }) => {
  return (
    <i
      className='web__icon'
      style={{
        width: size,
        height: size,
        backgroundColor: bgColor,
        display: 'inline-block',
        maskSize: size,
        maskRepeat: 'no-repeat',
        maskImage: `url(${icon})`,
        WebkitMaskSize: size,
        WebkitMaskRepeat: 'no-repeat',
        WebkitMaskImage: `url(${icon})`,
      }} />
  )
}

export default Icon